export abstract class DateTimeHelper {
  /**
   * Convert a number string date into a formated date string.
   * @param date The date in a digital format like 20201010 or 14440101.
   * @returns A date string in the format yyyy/MM/dd.
   */
  public static convertToHijri(date: string): string | null {
    if (!date || date.length !== 8) {
      return null;
    }

    return `${date.substring(0, 4)}/${date.substring(4, 6)}/${date.substring(6, 8)}`;
  }
}
